var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/hooks/use-get-widget-container.hook.ts
import { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import { Auth } from "@leagueplatform/auth";

// src/utils/get-observability-context.ts
var getObservabilityContext = (context) => __spreadProps(__spreadValues({}, context), {
  tags: __spreadValues({
    dependentModule: "masonry",
    supportTeam: "masonry-web"
  }, context == null ? void 0 : context.tags)
});

// src/utils/get-widget-container.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_WIDGET_CONTAINER = "get_widget_container";
var getWidgetContainer = (appId, version, apiParams, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch.fetch(
    {
      message_type: GET_WIDGET_CONTAINER,
      info: __spreadValues({
        type: appId,
        version
      }, apiParams && { api_params: apiParams })
    },
    {
      errorContext
    },
    { containerId: appId }
  );
});

// src/hooks/use-get-widget-container.hook.ts
var GET_WIDGET_CONTAINER2 = "get_widget_container";
var useGetWidgetContainer = (appId, version, apiParams, errorContext = {}) => {
  const queryClient = useQueryClient();
  useEffect(
    () => () => {
      setTimeout(() => {
        Auth.isAuthorized().then((isAuthorized) => {
          if (isAuthorized) {
            queryClient.refetchQueries([GET_WIDGET_CONTAINER2, appId, version]);
          }
        });
      }, 500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return useQuery(
    [GET_WIDGET_CONTAINER2, appId, version],
    () => getWidgetContainer(
      appId,
      version,
      apiParams,
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - get widget container api error",
        tags: __spreadValues({
          container: appId,
          apiVersion: version
        }, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    )
  );
};

// src/hooks/use-get-widget-data.hook.ts
import { useEffect as useEffect2 } from "react";
import { useQuery as useQuery2, useQueryClient as useQueryClient2 } from "react-query";

// src/utils/get-widget-data.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
var GET_WIDGET_DATA = "get_widget_data";
var getWidgetData = (params, version, widgetId, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch2.fetch(
    {
      message_type: GET_WIDGET_DATA,
      info: __spreadProps(__spreadValues({}, params), {
        version
      })
    },
    {
      errorContext
    },
    { widgetId }
  );
});

// src/utils/normalize-paramters.ts
var normalizeParams = ({
  params = []
}) => params.reduce(
  (paramObj, { key, value }) => __spreadProps(__spreadValues({}, paramObj), { [key]: value }),
  {}
);

// src/hooks/use-get-widget-data.hook.ts
import { Auth as Auth2 } from "@leagueplatform/auth";
var GET_WIDGET_DATA2 = "get_widget_data";
var useGetWidgetData = (widget, version, errorContext = {}) => {
  const { id: widgetId, links } = widget;
  const queryClient = useQueryClient2();
  const linkDetails = links.find(({ rel }) => rel === "data");
  useEffect2(
    () => () => {
      setTimeout(() => {
        Auth2.isAuthorized().then((isAuthorized) => {
          if (isAuthorized) {
            queryClient.refetchQueries([GET_WIDGET_DATA2, widgetId, version]);
          }
        });
      }, 500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return useQuery2(
    [GET_WIDGET_DATA2, widgetId, version],
    () => getWidgetData(
      normalizeParams({ params: linkDetails == null ? void 0 : linkDetails.params }),
      version,
      widgetId,
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - get widget data api error",
        tags: __spreadValues({
          widgetId,
          apiVersion: version
        }, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    ),
    {
      onSuccess: (data) => {
        if (!(data == null ? void 0 : data.attributes)) {
          console.warn(
            `[Masonry]: No attributes returned from api get_widget_data for widget id %c'${data.id}'`
          );
        }
      }
    }
  );
};

// src/hooks/use-post-dismiss-widget.hook.ts
import { useQuery as useQuery3 } from "react-query";

// src/utils/post-widget-dismiss.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var postWidgetDismiss = (messageType, params, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch3.fetch(
    {
      message_type: messageType,
      info: __spreadValues({}, params)
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-post-dismiss-widget.hook.ts
var usePostDismissWidget = (dismissed, link, errorContext = {}) => {
  const { href = "", params } = link || {};
  useQuery3(
    [href],
    () => postWidgetDismiss(
      href,
      normalizeParams({ params }),
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - post dismiss widget api error",
        tags: __spreadValues({}, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    ),
    { enabled: dismissed }
  );
};

// src/hooks/use-generate-pdf-report.hook.ts
import { useQuery as useQuery4 } from "react-query";

// src/utils/get-container-pdf.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var getContainerPDF = (messageType, params, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch4.fetch(
    {
      message_type: messageType,
      info: __spreadValues({}, params)
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-generate-pdf-report.hook.ts
var GET_CONTAINER_PDF = "get_container_pdf";
var useGeneratePDFReport = (generatePDF, {
  containerId: container_id,
  filename,
  templateId: template_id,
  version
}, errorContext = {}) => useQuery4(
  [GET_CONTAINER_PDF],
  () => getContainerPDF(
    GET_CONTAINER_PDF,
    __spreadValues({
      container_id,
      filename,
      version
    }, template_id && { template_id }),
    getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
      errorName: "Masonry - get container pdf widget api error",
      tags: __spreadValues({}, (errorContext == null ? void 0 : errorContext.tags) || {})
    }))
  ),
  { enabled: generatePDF }
);

// src/hooks/use-invalidate-get-container-request.hook.ts
import { useCallback } from "react";
import { useQueryClient as useQueryClient3 } from "react-query";
var useInvalidateContainerRequest = (appId, version) => {
  const queryClient = useQueryClient3();
  return useCallback(() => {
    queryClient.invalidateQueries([GET_WIDGET_CONTAINER2, appId, version]);
  }, [appId, version, queryClient]);
};

// src/hooks/use-invalidate-get-widget-request.hook.ts
import { useCallback as useCallback2 } from "react";
import { useQueryClient as useQueryClient4 } from "react-query";
var useInvalidateGetWidgetRequest = (widgetId, version) => {
  const queryClient = useQueryClient4();
  return useCallback2(() => {
    queryClient.invalidateQueries([GET_WIDGET_DATA2, widgetId, version]);
  }, [widgetId, version, queryClient]);
};

// src/types/widget-data.ts
var Orientation = /* @__PURE__ */ ((Orientation2) => {
  Orientation2["VERTICAL"] = "vertical";
  Orientation2["HORIZONTAL"] = "horizontal";
  Orientation2["GRID"] = "grid";
  return Orientation2;
})(Orientation || {});
var SupportedMedia = /* @__PURE__ */ ((SupportedMedia2) => {
  SupportedMedia2["MOBILE"] = "mobile";
  SupportedMedia2["TABLET"] = "tablet";
  SupportedMedia2["LAPTOP"] = "laptop";
  SupportedMedia2["DESKTOP"] = "desktop";
  return SupportedMedia2;
})(SupportedMedia || {});

// src/types/widget-types.ts
var WidgetType = /* @__PURE__ */ ((WidgetType2) => {
  WidgetType2["SMALL_VISUAL_CARD"] = "text_with_small_image";
  WidgetType2["LARGE_VISUAL_CARD"] = "text_with_large_image";
  WidgetType2["TEXT_WITH_CTA_CARD"] = "text_with_button";
  WidgetType2["CAROUSEL"] = "carousel";
  WidgetType2["HEALTH_JOURNEY"] = "health_journey";
  WidgetType2["WELCOME_BANNER"] = "welcome_banner";
  WidgetType2["HERO_BANNER"] = "heroBanner";
  WidgetType2["PRODUCT_CAROUSEL"] = "product_carousel";
  WidgetType2["NOTIFICATION_BANNER"] = "notification_banner";
  WidgetType2["NOTIFICATION_CARD"] = "notification_card";
  WidgetType2["XS_VISUAL_CARD"] = "xs_visual_card";
  WidgetType2["VERTICAL_STACK_XS"] = "vertical_stack_xs";
  WidgetType2["IMAGE_FOOTER"] = "image_footer";
  WidgetType2["CUSTOM_COMPONENT"] = "custom_component";
  WidgetType2["PROGRESS_BAR"] = "progress_bar";
  WidgetType2["PROGRESS_RING"] = "progress_ring";
  WidgetType2["TWO_UP_CARD"] = "2_up_card";
  WidgetType2["SECTION_HEADER"] = "section_header";
  WidgetType2["STACK"] = "stack";
  WidgetType2["GENERIC_CAROUSEL"] = "genericCarousel";
  WidgetType2["METRIC_CARD"] = "metricCard";
  WidgetType2["HIDDEN"] = "hidden";
  return WidgetType2;
})(WidgetType || {});

// src/__mocks__/get-widget-container.mocks.ts
var getWidgetContainerMock = {
  type: "b2b_care_homepage",
  widgets: [
    {
      id: "6739f94fca803fd3fb6db4b11db7302a",
      type: "section_header" /* SECTION_HEADER */,
      name: "How can we help you",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "6739f94fca803fd3fb6db4b11db7302a"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "821ab100fcb5605d683fff1779a017a8",
      type: "text_with_large_image" /* LARGE_VISUAL_CARD */,
      name: "how can we help Items",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "821ab100fcb5605d683fff1779a017a8"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "04e87b5f290fd3063af7c5c5af5b4e00",
      type: "stack" /* STACK */,
      name: "Care Providers List",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "04e87b5f290fd3063af7c5c5af5b4e00"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "e5a5bc5ebb5cd237e425efdc9dcf4a1f",
      type: "carousel" /* CAROUSEL */,
      name: "Recommended QuickActions Menu Items",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "e5a5bc5ebb5cd237e425efdc9dcf4a1f"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    }
  ]
};

// src/types/loader-types.ts
var LoaderType = /* @__PURE__ */ ((LoaderType2) => {
  LoaderType2["SMALL"] = "loadingSmall";
  LoaderType2["LARGE"] = "loadingLarge";
  LoaderType2["EXTRA_SMALL"] = "loadingExtraSmall";
  LoaderType2["HERO_BANNER"] = "loadingHeroBanner";
  return LoaderType2;
})(LoaderType || {});

// src/__mocks__/get-widget-container-v2.mocks.ts
var getWidgetContainerV2Mock = {
  type: "homescreen",
  widgets: [
    {
      id: "current_default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_default"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "current_default_with_loading",
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_default_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "current_custom_component",
      custom_type: "health_journey",
      module: "health_journey",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_custom_component"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 4. (NEW) Current custom component with loading
    {
      id: "current_custom_component_with_loading",
      // custom_type: 'health_journey',
      module: "health_journey",
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_custom_component_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 5. (NEW) Custom component without loading
    {
      id: "new_custom_component_without_loading",
      // custom_type: 'health_journey',
      module: "health_journey",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "new_custom_component_without_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 6. (NEW) Custom component with loading
    {
      id: "new_custom_component_with_loading",
      module: "health_journey",
      // custom_type: 'health_journey',
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "new_custom_component_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    }
  ]
};

// src/__mocks__/get-widget-data.mocks.ts
var getWidgetDataMock = {
  id: "6739f94fca803fd3fb6db4b11db7302a",
  type: "section_header",
  product_identifier: "get_care",
  attributes: {
    heading: "How can we help you?"
  },
  links: [
    {
      rel: "self",
      type: "GET",
      href: "get_widget_data",
      params: [
        {
          key: "widget_id",
          value: "6739f94fca803fd3fb6db4b11db7302a"
        },
        {
          key: "version",
          value: "1"
        }
      ],
      protocol: "websocket"
    }
  ],
  traits: {}
};

// src/__mocks__/get-widget-data-v2.mocks.ts
var getWidgetDataV2DefaultComponentMock = {
  id: "new_default_component_mock",
  type: "text_with_large_image",
  product_identifier: "get care",
  attributes: {
    title: "cool test custom component",
    description: "cool test custom component",
    image: "https://www.searchenginejournal.com/wp-content/uploads/2022/06/image-search-1600-x-840-px-62c6dc4ff1eee-sej.png"
  },
  links: [
    {
      rel: "data",
      type: "GET",
      href: "get_widget_data",
      params: [
        {
          key: "widget_id",
          value: "new_default_component_mock"
        },
        {
          key: "version",
          value: "1"
        }
      ],
      protocol: "websocket"
    }
  ],
  traits: {}
};
var getWidgetDataV2CustomComponentMock = {
  id: "new_custom_component_mock",
  type: "health_journey",
  module: "journey",
  product_identifier: "get care",
  attributes: {
    title: "cool test custom component",
    description: "cool test custom component",
    image: "https://www.searchenginejournal.com/wp-content/uploads/2022/06/image-search-1600-x-840-px-62c6dc4ff1eee-sej.png"
  },
  links: [
    {
      rel: "data",
      type: "GET",
      href: "get_widget_data",
      params: [
        {
          key: "widget_id",
          value: "new_custom_component_mock"
        },
        {
          key: "version",
          value: "1"
        }
      ],
      protocol: "websocket"
    }
  ]
};

// src/masonry-engine/masonry-ws-root-node/get-masonry-WS-root-node.ts
import { omit } from "lodash";
import { v4 as uuidv4 } from "uuid";

// src/utils/analytics-events-for-masonry-WS-driver.ts
import { trackAnalyticsEvent, EVENT_NAME } from "@leagueplatform/analytics";

// src/constants/analytics-event-detail-mapping.ts
var DetailLargeVisualCardButtonClick = "text_with_large_image";
var DetailSmallVisualCardButtonClick = "text_with_small_image";
var DetailXSVisualCardButtonClick = "text_with_xsmall_image";
var DetailNotificationBannerButtonClick = "notification_banner";
var DetailNotificationBannerDismissClick = "notification_banner_dismiss_button";
var DetailNotificationCardButtonClick = "notification_card";
var DetailProgressRingButtonClick = "progress_ring";
var DetailProgressBarButtonClick = "progress_bar";
var DetailHeroBannerButtonClick = "welcome_banner_primary_button";
var DetailTextWithCTAButtonClick = "text_with_button_primary_button";
var Detail2UpCardWithCTAButtonClick = "2_up_card";
var DetailMetricCardButtonClick = "metric_card";
var DetailCarouselScrollRight = "scroll carousel right";
var DetailCarouselScrollLeft = "scroll carousel left";
var DetailCarouselHeaderButtonClick = "carousel_header_button";
var DetailCarouselHeaderSelectItem = "select item from carousel";
var DetailStackSelectItem = "select item from stack";

// src/utils/analytics-events-for-masonry-WS-driver.ts
var getDataForAnalyticsByWidgetType = (type, widgetAnalyticsData) => {
  switch (type) {
    case "xs_visual_card" /* XS_VISUAL_CARD */:
      return {
        text_detail: widgetAnalyticsData.heading,
        text_sub_detail: widgetAnalyticsData.body,
        link_url: widgetAnalyticsData.linkUrl
      };
    case "progress_bar" /* PROGRESS_BAR */:
      return {
        text_detail: widgetAnalyticsData.eyebrow,
        current_progress: widgetAnalyticsData.currentText,
        maximum_progress: widgetAnalyticsData.suffixText,
        remaining_progress: widgetAnalyticsData.footerText,
        progress_percent: widgetAnalyticsData.progress,
        link_url: widgetAnalyticsData.action
      };
    case "progress_ring" /* PROGRESS_RING */:
      return {
        text_detail: widgetAnalyticsData.eyebrow,
        current_progress: widgetAnalyticsData.currentText,
        maximum_progress: widgetAnalyticsData.suffixText,
        progress_percent: widgetAnalyticsData.progress,
        link_url: widgetAnalyticsData.action
      };
    case "heroBanner" /* HERO_BANNER */:
      return {
        text_detail: widgetAnalyticsData.buttonLabel,
        link_url: widgetAnalyticsData.buttonAction
      };
    case "notification_card" /* NOTIFICATION_CARD */:
      return {
        text_detail: widgetAnalyticsData.heading,
        text_sub_detail: widgetAnalyticsData.subheading,
        link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url
      };
    case "metricCard" /* METRIC_CARD */:
      return {
        text_detail: widgetAnalyticsData.heading
      };
    default:
      return {
        text_detail: widgetAnalyticsData.title,
        text_sub_detail: widgetAnalyticsData.description,
        link_url: widgetAnalyticsData.linkUrl
      };
  }
};
var getAnalyticsEventsForMasonryWSDriver = (widgetType, widgetAnalyticsData, appId, productArea, screenName, productIdentifier) => {
  const trackMasonryAnalytics = (event, widgetProperties) => () => trackAnalyticsEvent(event, __spreadValues({
    product_area: productArea,
    sub_product_area: appId,
    screen_name: screenName,
    product_identifier: productIdentifier
  }, widgetProperties));
  const getCarouselAnalyticEvents = () => {
    var _a, _b;
    const carouselRollup = {
      carousel_array: (_a = widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.items) == null ? void 0 : _a.map(
        (carouselItem) => carouselItem.title
      ),
      carousel_name: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.title,
      carousel_num_resources: (_b = widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.items) == null ? void 0 : _b.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onSelectItem: (item, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        sub_detail: item.title,
        text_detail: item.overline,
        carousel_index: index,
        link_url: item.linkUrl
      }, carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerLinkHint,
        link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerLinkUrl
      }, carouselRollup))
    };
  };
  const getTwoUpCardAnalyticsEvent = () => ({
    onItemClick: ({ heading, body, actionLink }, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, {
      detail: Detail2UpCardWithCTAButtonClick,
      text_detail: heading,
      text_sub_detail: body,
      container_index: index,
      link_url: actionLink
    })()
  });
  const getNotificationBannerAnalyticsEvent = () => __spreadProps(__spreadValues({}, (widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url) && {
    onCardClick: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, {
      detail: DetailNotificationBannerButtonClick,
      text_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.heading,
      text_sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.body,
      link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url
    })
  }), {
    onDismiss: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, {
      detail: DetailNotificationBannerDismissClick,
      text_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.heading,
      text_sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.body,
      link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url
    })
  });
  const getStackAnalyticsEvents = () => {
    const stackRollup = {
      stack_array: widgetAnalyticsData.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      stack_name: widgetAnalyticsData.heading,
      stack_num_resources: widgetAnalyticsData.items.length
    };
    return {
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailStackSelectItem,
        stack_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(type, attributes)), stackRollup))()
    };
  };
  const getGenericCarouselAnalyticsEvents = () => {
    const carouselRollup = {
      carousel_array: widgetAnalyticsData.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      carousel_name: widgetAnalyticsData.heading,
      carousel_num_resources: widgetAnalyticsData.items.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        carousel_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(type, attributes)), carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerButtonLabel,
        link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerButtonAction
      }, carouselRollup))
    };
  };
  const getCommonAnalyticsEvent = (widgetDetail) => () => ({
    onCardClick: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
      detail: widgetDetail
    }, getDataForAnalyticsByWidgetType(widgetType, widgetAnalyticsData)))
  });
  const getWidgetAnalyticsFromType = {
    /* ---- Complex Widgets ----*/
    ["carousel" /* CAROUSEL */]: getCarouselAnalyticEvents,
    ["2_up_card" /* TWO_UP_CARD */]: getTwoUpCardAnalyticsEvent,
    ["stack" /* STACK */]: getStackAnalyticsEvents,
    ["genericCarousel" /* GENERIC_CAROUSEL */]: getGenericCarouselAnalyticsEvents,
    /* ---- Simple Widgets ----*/
    ["heroBanner" /* HERO_BANNER */]: getCommonAnalyticsEvent(
      DetailHeroBannerButtonClick
    ),
    ["progress_bar" /* PROGRESS_BAR */]: getCommonAnalyticsEvent(
      DetailProgressBarButtonClick
    ),
    ["progress_ring" /* PROGRESS_RING */]: getCommonAnalyticsEvent(
      DetailProgressRingButtonClick
    ),
    ["xs_visual_card" /* XS_VISUAL_CARD */]: getCommonAnalyticsEvent(
      DetailXSVisualCardButtonClick
    ),
    ["notification_banner" /* NOTIFICATION_BANNER */]: getNotificationBannerAnalyticsEvent,
    ["notification_card" /* NOTIFICATION_CARD */]: getCommonAnalyticsEvent(
      DetailNotificationCardButtonClick
    ),
    ["text_with_button" /* TEXT_WITH_CTA_CARD */]: getCommonAnalyticsEvent(
      DetailTextWithCTAButtonClick
    ),
    ["text_with_large_image" /* LARGE_VISUAL_CARD */]: getCommonAnalyticsEvent(
      DetailLargeVisualCardButtonClick
    ),
    ["text_with_small_image" /* SMALL_VISUAL_CARD */]: getCommonAnalyticsEvent(
      DetailSmallVisualCardButtonClick
    ),
    ["metricCard" /* METRIC_CARD */]: getCommonAnalyticsEvent(
      DetailMetricCardButtonClick
    )
  };
  const widgetAnalyticsEventsFn = getWidgetAnalyticsFromType[widgetType];
  return widgetAnalyticsEventsFn ? widgetAnalyticsEventsFn() : {};
};

// src/utils/format-object-keys-to-camel-case.ts
var convertToCamelCase = (str) => str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
var formatObjectKeysToCamelCase = (obj = {}) => Object.keys(obj).reduce((finalObj, key) => {
  finalObj[convertToCamelCase(key)] = obj[key];
  return finalObj;
}, {});

// src/masonry-engine/masonry-ws-root-node/get-masonry-WS-root-node.ts
var formatCarouselOrStackResponse = (widget, analyticsProperties) => {
  var _a;
  const { id, type, attributes, traits } = widget;
  const { onItemClick } = analyticsProperties;
  return {
    id,
    type,
    properties: __spreadValues(__spreadProps(__spreadValues({}, omit(attributes, "items")), {
      traits
    }), analyticsProperties),
    sections: {
      items: (_a = attributes == null ? void 0 : attributes.items) == null ? void 0 : _a.map(
        (slot, index) => ({
          id: uuidv4(),
          type: slot.type,
          namespace: "default",
          properties: __spreadProps(__spreadValues({}, formatObjectKeysToCamelCase(slot.attributes)), {
            traits: slot.traits,
            // Each child of generic carousel/stack expects onCardClick instead of onItemClick callback event name
            onCardClick: () => onItemClick(widget, index)
          })
        })
      )
    }
  };
};
var getDismissibleLink = (links) => links == null ? void 0 : links.find((link) => link.rel === "dismiss");
var MASONRY_WS_API_VERSION = 2;
var getMasonryWSRootNode = ({
  appId,
  productArea,
  screenName,
  apiParams
}) => ({
  id: appId,
  type: "containerSpinner",
  properties: {},
  sections: {},
  namespace: "default",
  getAsyncSelf: () => __async(void 0, null, function* () {
    const containerData = yield getWidgetContainer(
      appId,
      MASONRY_WS_API_VERSION,
      apiParams
    );
    return {
      id: appId,
      /**
       * As all widgets in a container are shown vertically, thus setting
       * node type of Masonry WS container to a "stack" with orientation trait
       * set to "vertical".
       */
      type: "stack",
      properties: {
        traits: {
          mobile: {
            orientation: "vertical" /* VERTICAL */
          },
          tablet: {
            orientation: "vertical" /* VERTICAL */
          },
          laptop: {
            orientation: "vertical" /* VERTICAL */
          },
          desktop: {
            orientation: "vertical" /* VERTICAL */
          }
        }
      },
      namespace: "default",
      sections: {
        items: containerData.widgets.map((widget) => ({
          id: widget.id,
          type: widget.type || "loadingSmall" /* SMALL */,
          properties: {},
          sections: {},
          getAsyncSelf: () => __async(void 0, null, function* () {
            var _a;
            const linkDetails = widget.links.find(({ rel }) => rel === "data");
            const widgetResponse = yield getWidgetData(
              normalizeParams({ params: linkDetails == null ? void 0 : linkDetails.params }),
              MASONRY_WS_API_VERSION,
              widget.id
            );
            const analyticsProperties = getAnalyticsEventsForMasonryWSDriver(
              widgetResponse.type,
              widgetResponse.attributes,
              appId,
              productArea,
              screenName,
              widgetResponse.product_identifier
            );
            if (widgetResponse.type === "genericCarousel" || widgetResponse.type === "stack") {
              return formatCarouselOrStackResponse(
                widgetResponse,
                analyticsProperties
              );
            }
            return {
              id: widget.id,
              sections: {},
              namespace: widgetResponse.module,
              type: widgetResponse.type,
              properties: __spreadValues(__spreadProps(__spreadValues({}, widgetResponse.attributes ? formatObjectKeysToCamelCase(widgetResponse.attributes) : {}), {
                items: ((_a = widgetResponse.attributes) == null ? void 0 : _a.items) ? widgetResponse.attributes.items.map(
                  (item) => formatObjectKeysToCamelCase(item)
                ) : void 0,
                traits: widgetResponse.traits,
                dismissibleLink: getDismissibleLink(widgetResponse.links)
              }), analyticsProperties)
            };
          })
        }))
      }
    };
  })
});

// src/masonry-engine/masonry-root-node/get-masonry-root-node.ts
import {
  DEFAULT_NAMESPACE as DEFAULT_NAMESPACE2
} from "@leagueplatform/masonry-engine";

// src/masonry-engine/masonry-root-node/get-async-node-and-format-to-masonry-node.ts
import {
  DEFAULT_NAMESPACE
} from "@leagueplatform/masonry-engine";
import { deserialise } from "kitsu-core";

// src/utils/get-masonry-node.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
import { getConfig } from "@leagueplatform/config";
import {
  getCurrentBreakpoint
} from "@leagueplatform/masonry-engine";
var getMasonryNode = (_0) => __async(void 0, [_0], function* ({
  path,
  method,
  queryParams
}) {
  const url = new URL(path, window.location.origin);
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });
  }
  const completePath = url.href.replace(url.origin, "");
  const timeZone = typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Toronto";
  const response = yield leagueFetch(completePath, {
    method,
    allowUnauthenticated: true,
    headers: {
      "X-League-Client-Platform": "web",
      "X-League-Client-Time-Zone": timeZone,
      "X-League-Client-Version": getConfig().config.core.appVersion || "1.0.0",
      "X-League-Client-View-Size": getCurrentBreakpoint() || "desktop"
      // default to desktop if no clientViewSize is provided. A string value is required for this header as it cannot be undefined
      // Un-comment this if using mock data and pass mock node instead of params
      // Prefer: `code=200, example=cool-node`,
    }
  });
  if (!response.ok) {
    throw new Error(`getMasonryNode error: ${response.status}`);
  }
  const responseJson = yield response.clone().json();
  return responseJson;
});

// src/masonry-engine/masonry-root-node/get-async-node-and-format-to-masonry-node.ts
var getAsyncNode = (options) => __async(void 0, null, function* () {
  const data = yield getMasonryNode(options);
  return formatMasonryNode(data);
});
var formatSectionsToNode = (sectionsData) => sectionsData.reduce(
  (sections, activeSection) => {
    const sectionsList = sections;
    const {
      name: sectionName,
      nodes: { data: sectionData }
    } = activeSection;
    sectionsList[sectionName] = sectionData.map(
      (nodeInSection) => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        formatMasonryNode({
          data: nodeInSection,
          included: []
        })
      )
    );
    return sectionsList;
  },
  {}
);
var formatMasonryNode = (data) => {
  var _a;
  const formattedData = deserialise(data);
  const getNodeMeta = (_a = data.data.meta) == null ? void 0 : _a.getNode;
  const {
    node: { actions, properties, type, namespace },
    sections,
    id
  } = formattedData.data;
  const nodeValue = {
    id,
    type,
    properties: properties || {},
    namespace: namespace || DEFAULT_NAMESPACE,
    actions: actions || {},
    sections: sections ? formatSectionsToNode(sections.data) : {},
    getAsyncSelf: getNodeMeta ? (queryParams) => getAsyncNode({
      path: getNodeMeta.href,
      method: getNodeMeta.method,
      queryParams
    }) : void 0
  };
  return nodeValue;
};

// src/constants/masonry-node-api.ts
var GET_MASONRY_NODE_ENDPOINT = "/v1/masonry-node/";
var MASONRY_NODE_DISMISS_ENDPOINT = "v1/masonry-node/dismiss";

// src/masonry-engine/masonry-root-node/get-masonry-root-node.ts
var getMasonryRootNode = ({
  rootNodeId
}) => ({
  id: rootNodeId,
  type: "containerSpinner",
  // Replace this with spinner renderer
  properties: {},
  sections: {},
  namespace: DEFAULT_NAMESPACE2,
  getAsyncSelf: (queryParams) => __async(void 0, null, function* () {
    return getAsyncNode({
      path: `${GET_MASONRY_NODE_ENDPOINT}${rootNodeId}`,
      method: "GET",
      queryParams
    });
  })
});

// src/utils/post-masonry-node-dismiss.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
var postMasonryNodeDismiss = (nodeId) => __async(void 0, null, function* () {
  const response = yield leagueFetch2(MASONRY_NODE_DISMISS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      data: {
        type: "dismissed",
        id: nodeId
      }
    })
  });
  if (response.ok) {
    return true;
  }
  throw new Error(`Masonry Dismiss Action Error:${response.status}`);
});

// src/utils/delete-masonry-node-dismiss.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
var deleteMasonryNodeDismiss = (nodeIds) => __async(void 0, null, function* () {
  const response = yield leagueFetch3(MASONRY_NODE_DISMISS_ENDPOINT, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      data: {
        type: "un-dismissed",
        attributes: {
          nodeIds
        }
      }
    })
  });
  if (response.ok) {
    return true;
  }
  throw new Error(`Masonry Undismiss Action Error:${response.status}`);
});

// src/utils/post-masonry-form.ts
import { leagueFetch as leagueFetch4 } from "@leagueplatform/league-fetch";

// src/constants/masonry-form-api.ts
var POST_MASONRY_FORM = "/v1/masonry-form";

// src/utils/format-form-fields.ts
var formatFormFields = (fieldNodes) => fieldNodes.map(({ nodeId, value, formFieldProperties: { formFieldId } }) => ({
  nodeId,
  value,
  formFieldId
}));

// src/utils/post-masonry-form.ts
var postMasonryForm = (_0) => __async(void 0, [_0], function* ({
  formId,
  formProcessId,
  fieldNodes
}) {
  const url = `${POST_MASONRY_FORM}/${formId}`;
  const body = {
    formProcessId,
    formFields: formatFormFields(fieldNodes)
  };
  const response = yield leagueFetch4(url, {
    method: "POST",
    allowUnauthenticated: true,
    body: JSON.stringify(body)
  });
  const responseJson = yield response.clone().json();
  return {
    data: responseJson == null ? void 0 : responseJson.data,
    status: response.status,
    ok: response.ok
  };
});
export {
  GET_WIDGET_CONTAINER2 as GET_WIDGET_CONTAINER,
  GET_WIDGET_DATA2 as GET_WIDGET_DATA,
  LoaderType,
  Orientation,
  SupportedMedia,
  WidgetType,
  deleteMasonryNodeDismiss,
  getMasonryNode,
  getMasonryRootNode,
  getMasonryWSRootNode,
  getObservabilityContext,
  getWidgetContainerMock,
  getWidgetContainerV2Mock,
  getWidgetDataMock,
  getWidgetDataV2CustomComponentMock,
  getWidgetDataV2DefaultComponentMock,
  postMasonryForm,
  postMasonryNodeDismiss,
  postWidgetDismiss,
  useGeneratePDFReport,
  useGetWidgetContainer,
  useGetWidgetData,
  useInvalidateContainerRequest,
  useInvalidateGetWidgetRequest,
  usePostDismissWidget
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-api'] = window.leagueSDKsPresent['@leagueplatform/masonry-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-api'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/masonry-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/masonry-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map